import debug from '../utils/console'

const logger = debug.withTag('plugins:google-tag-manager')

export default defineNuxtPlugin(async (nuxtApp) => {
  const { googleTagManagerId, redesignedNtpPaths } = useAppConfig()
  const { gtag, initialize } = useGtag()
  const route = useRoute()

  const { client } = await useOpenFeature()

  if (!googleTagManagerId) {
    logger.warn('Google Tag Manager: Gtag ID not available in app config')
    return
  }

  initialize(googleTagManagerId)

  // Maintain window.dataLayer field for legacy pages
  if (!import.meta.dev && !redesignedNtpPaths.includes(route.path)) {
    gtag('js', new Date())
    gtag('config', 'UA-62117061-22')
  }

  nuxtApp.hook('app:mounted', () => {
    try {
      window.googletag = window.googletag || { cmd: [] }
      const disabledFallback = 'nofallback' in route.query

      window.googletag.cmd.push(() => {
        if (!window.googletag.pubads || disabledFallback) {
          logger.error('addEventListener: Gtag pubads not found')
          return
        }
        window.googletag
          .pubads()
          .addEventListener('slotRenderEnded', setupNativeAdAsFallback)

        //page level targeting with split test name
        window.googletag.setConfig({
          targeting: {
            page_type: getPageType(),
            split_test_name: client.getStringValue('splittestname', 'default'),
          },
        })
      })
    } catch (err) {
      logger.error('Error mounting event listeners for native fallback', err)
    }
  })
})
